function t(n) {
  return `${n}-${Math.random().toString(36).substring(2, 11)}`;
}
export {
  t as generateRandomId
};
